import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

import DatasetComparison from "./DatasetComparison";
import DatasetComparisonSkeleton from "./DatasetComparison.skeleton";

import { useGetCsobDatasetComparison } from "@api";
import { Alert } from "@components/base";
import { useUserStore } from "@store/user";

const DatasetComparisonContainer: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const {
    csobDatasetComparison,
    csobDatasetComparisonEnabled,
    isFetchingGetCsobDatasetComparison,
    refetchCsobDatasetComparison,
  } = useGetCsobDatasetComparison(user, true);

  useEffect(() => {
    if (csobDatasetComparisonEnabled) {
      refetchCsobDatasetComparison();
    }
  }, [csobDatasetComparisonEnabled]);

  return (
    csobDatasetComparisonEnabled &&
    (isFetchingGetCsobDatasetComparison ? (
      <DatasetComparisonSkeleton />
    ) : csobDatasetComparison ? (
      <DatasetComparison csobDatasetComparison={csobDatasetComparison} />
    ) : (
      <Alert severity="error">{t("csob.datasetComparisonError")}</Alert>
    ))
  );
};

export default DatasetComparisonContainer;
